import axios from 'axios'
import {baseUrl} from '../config'

type ValidLoginData = {
  party_id: string
  election_id: string
}

export async function validateLoginData(dataString: string): Promise<{data: ValidLoginData}> {
  return await axios.post(`${baseUrl}/validate-data`, {
    dataString
  })
}
